<div class="flex justify-center items-center h-full">
  <div class="bg-white p-2xl rounded-xl screen-warning-container shadow-xl">
    <div class="text-center flex flex-col items-center">
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="32" fill="var(--color-primary-50)" />
        <path
          opacity="0.4"
          d="M45.2927 24.5441V33.2107H18.666V24.5441C18.666 21.3041 21.306 18.6641 24.546 18.6641H39.4127C42.6527 18.6641 45.2927 21.3041 45.2927 24.5441Z"
          fill="var(--color-primary-500)" />
        <path
          d="M18.666 33.2266V33.4932C18.666 36.7466 21.306 39.3732 24.546 39.3732H29.666C30.3993 39.3732 30.9993 39.9732 30.9993 40.7066V41.9999C30.9993 42.7332 30.3993 43.3332 29.666 43.3332H26.4393C25.8927 43.3332 25.4393 43.7866 25.4393 44.3332C25.4393 44.8799 25.8793 45.3332 26.4393 45.3332H37.5727C38.1194 45.3332 38.5727 44.8799 38.5727 44.3332C38.5727 43.7866 38.1194 43.3332 37.5727 43.3332H34.346C33.6127 43.3332 33.0127 42.7332 33.0127 41.9999V40.7066C33.0127 39.9732 33.6127 39.3732 34.346 39.3732H39.426C42.6793 39.3732 45.306 36.7332 45.306 33.4932V33.2266H18.666Z"
          fill="var(--color-primary-500)" />
      </svg>

      <h2 class="my-2xl font-medium text-lg">
        {{ 'screen_warning_title' | transloco }}
      </h2>

      <p class="text-sm text-neutral-500">
        {{ 'screen_warning_description' | transloco }}
      </p>
    </div>
  </div>
</div>
